






import Vue from 'vue';
import Table from '@/components/table/newTable/Table.vue';
import { columns } from '@/configs/existReportsConfigs';
import { TTableColumns } from '@/components/table/types';

export default Vue.extend({
  name: 'ExistReports',
  components: { Table },

  mounted() {
    this.$store.commit('changeTitle', this.$t('pages.existReports.title'));
  },

  data() {
    return {
      data: columns.getData(),
      columns: columns.formating().getColumns() as TTableColumns,
    };
  },
});
